import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[validatePhoneNumber]'
})
export class ValidatePhoneNumberDirective {

  private allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
  
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (!this.allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}